import './DronesOnline.css'
import {useEffect, useState} from "react";
import {droneService, DroneType, Header, IDronesOnlineList, Pagination} from "@shared/ui";
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DronesOnline: React.FC = () => {
    const { t } = useTranslation();
    const [dronesData, setDronesData] = useState<IDronesOnlineList[]>([]);
    const [currentPageDrones, setCurrentPageDrones] = useState<number>(1);
    const pageSize = 20;
    const [totalPagesDrones, setTotalPagesDrones] = useState(1);
    const [isFilterByType, setFilterByType] = useState(false);
    const [isSearchByNumber, setSearchByNumber] = useState(false);
    const [filterByType, setFilterType] = useState<DroneType | null>(null);
    const [searchByDroneNumber, setSearchByDroneNumber] = useState<string | null>(null);

    const handleFilterByType = () => {
        setFilterByType(prev => !prev);
    }
    const handleSearchByNumber = () => {
        setSearchByNumber(prev => !prev);
    }

    const handlePageChange = (page: number) => {
        setCurrentPageDrones(page);
    };

    useEffect(() => {
        droneService.getDronesOnline(currentPageDrones, pageSize, filterByType, searchByDroneNumber)
            .then(data => {
                setDronesData(data.items);
                setTotalPagesDrones(data.totalPageCount)
            }).catch();
    }, [filterByType, searchByDroneNumber, currentPageDrones]);

    const donesOnline = {
        totalPageCount: 2,
        totalItemCount: 19,
        currentPageNumber: 2,
        pageSize: 20,
        items: [
            {
                id: '08dddf0b-fc21-448f-8c18-a8c468c1590e',
                name: 'Віслюк 1',
                number: 'Логіст',
                type: DroneType.Pixel,
                isDroneOnline: true,
                isDroneUse: true,
                customer: '34',
            }
        ]
    }
    return (
        <div className="container">
            <Header />

            <table className="diagnostic-table drones-online-wrapper">
                <tr>
                    <th>{t("dronesOnline.table.name")}</th>
                    <th className="search-wrapper">
                        <div className="th-content" onClick={handleSearchByNumber}>
            <span>
            {t("dronesOnline.table.number")}
            </span>
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUElEQVR4nO3ZK0gEURSA4d8HysCCRTAYDBu2GCyWTSaTGmw2m81oFrcabTabySAmQTD4wG4xGASDIAgiKovukYURZHF2ZnZn7j13OR+cOMP54U6ZC0a3G0ACmetuIRLYJPK9mFhIhysFy0nGae+aaBK4VbCkpMwdMEWKaeBewbKSMA/ADBlVgUcFS0vHPAE1cpoFnhUsL/G8AHP0aB54VRDxBtTpUz1+ka+Id2CBgiwCnx4imsASBVsFvhxGfANrlGQdaDmIaAEblGzTQcgWjjRKjNjBsd0SIvbwYAjYLzDiABjGkxHgsICII2AUz8aAkz4iToFxlIiA8x4iLoEKykwAZzkiLuJnjMkg7zeilliIMmIhyoiFKCMWooxYiDJiIcqIhQR+va1WBGwDH6GH/L3xOh6EkF/LKfeRQYm6HLcgVf85bkFbie/J2/+1zMD6ASkChKhyym4dAAAAAElFTkSuQmCC"
                                className="filter-icon"
                                height="15"
                                alt="filter--v1" />
                        </div>
                        <div className={`filter-control ${isSearchByNumber ? 'open' : ''}`}>
                            {isSearchByNumber && <input name="search" type="text" onChange={(e) => {
                                setSearchByDroneNumber(e.target.value);
                            }} />}
                        </div>
                    </th>
                    <th className="search-wrapper">
                        <div className="th-content"  onClick={handleFilterByType}>
            <span>
              {t("dronesOnline.table.type")}
            </span>
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUElEQVR4nO3ZK0gEURSA4d8HysCCRTAYDBu2GCyWTSaTGmw2m81oFrcabTabySAmQTD4wG4xGASDIAgiKovukYURZHF2ZnZn7j13OR+cOMP54U6ZC0a3G0ACmetuIRLYJPK9mFhIhysFy0nGae+aaBK4VbCkpMwdMEWKaeBewbKSMA/ADBlVgUcFS0vHPAE1cpoFnhUsL/G8AHP0aB54VRDxBtTpUz1+ka+Id2CBgiwCnx4imsASBVsFvhxGfANrlGQdaDmIaAEblGzTQcgWjjRKjNjBsd0SIvbwYAjYLzDiABjGkxHgsICII2AUz8aAkz4iToFxlIiA8x4iLoEKykwAZzkiLuJnjMkg7zeilliIMmIhyoiFKCMWooxYiDJiIcqIhQR+va1WBGwDH6GH/L3xOh6EkF/LKfeRQYm6HLcgVf85bkFbie/J2/+1zMD6ASkChKhyym4dAAAAAElFTkSuQmCC"
                                className="filter-icon"
                                height="15"
                                alt="filter--v1" />
                        </div>
                        <div className={`filter-control ${isFilterByType ? 'open' : ''}`}>
                            {isFilterByType && <select
															value={filterByType ?? ''}
															onChange={(e) => {
                                  const value = e.target.value;
                                  setFilterType(value ? (value as DroneType) : null);
                              }
                              }
														>
															<option value="">— not selected —</option>

                                {Object.values(DroneType).map(type => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
														</select>}
                        </div>

                    </th>
                    <th>{t("dronesOnline.table.status")}</th>
                    <th>{t("dronesOnline.table.customer")}</th>
                    <th style={{width: '140px'}}></th>
                </tr>
                {dronesData.map(drone => {
                    return (
                        <tr>
                            <td>{drone.name}</td>
                            <td>{drone.description}</td>
                            <td>{drone.type}</td>
                            <td> {drone.isDroneOnline && <span className="on-line">Online</span>}
                                {drone.isDroneUse && <span className="on-use">{t("dronesOnline.onUse")}</span>}</td>
                            <td>{drone.customerId}</td>
                            <td>
                                <NavLink
                                    className="btn"
                                    to={'/dashboard/' + drone.id}
                                    title={t("dronesOnline.buttons.info")}
                                >
                                    <img
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACL0lEQVR4nO2ay04bMRSGv10m3QCVKGm7gqcpAiq65fIOIKDhGYBNpUqgLvsIqRBQ3qBq1WXTcNmVBYKuQQQZWTqLaORMMp7juUT80i9Fk+j4fPGxx/YMPGt09RJYBPaAQ6AN/AfuxfbzH/luV347QUkUAavAKfAImJTuAifAisTKXXVgE7jySL6fbawNiZ2L5oFLRYC4L4C5kAC26z8FBIj7K/BCG+I18DtHCCP+CTS0IGaku01BPpccMukV0CkQwvSMG++eqRdUTqaPf/lO0V8yNmxvgh+BN+KmXMsSc99nis36D9rE42oqxJ1NU1Iag9vOdHE1lAZ/NAzIllJN23KK661S7PVBEJHissNVWttKsf8N6pVVpYaMDOym8mA3PV5OAjlVbCi0j5P2E90SJGiGtM113AXyoQTJmZR+7wLZK0FiJqV3XCCHig30kzZIy9VIp4IgbVcjtwEaCg1y7QK5ryDI3UiD3I5KaXUqCNIOPf3mBdLK64YYGmTHBbJYQZAFF8hEgEVjSJAHYIw++l4hkCMStFIhkKUkkJpsI8sOcjXMAcRGBUDWyOk4aJCyxD5Lc+I4V2KQd6TUgWIpaPkzHork+YQpiX/IZOSlSeBvCSDOgSkyakYCFQkxjZIa8nyiiHKaQlm1Ah6G1gmo2cClduYzxfoqkqN9zeWMjbVW1BsQNVloHntuAbqyil3OMrVqa1zOYu2u7Zu8QHPT81LNjVxryW8WkvYTz6LiegLEbQpuaAx++AAAAABJRU5ErkJggg=="
                                        height="25"
                                        alt="info" />
                                </NavLink>
                                <NavLink
                                    className="btn"
                                    to={'/settings/' + drone.id}
                                    title={t("dronesOnline.buttons.settings")}
                                >
                                    <img
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC2UlEQVR4nO2av2sUQRTHP8FgUHMngtHCHwg5UCNioqIRS7HRXi099A8wxM4YECGiYv6CWNl5iIWtgoVGLKKthSjmULhYaZFc7pJbGXgLy7ruzszO3e6d+cIXApmbed/deTvffW9hA/8H7gPrgBdiE5iki1CNEOHzA12CItCKEVIH+ukCjMeI8HkoywD3AxPAUMK4soaQSwlzDAE3gH04xgHgqwRRAy7GjH2oIeROzO/PAd9lnMq1kisRpYjkVTnwCBgIjd0BvNEQ8goohH67WS5COL8WgeF2iAjyIzAiefEcWNUQ4XMZeAIcBQ4CCzFjU4nZmyDCZ8Mg+CiqO7CiMW4R2GMjRCdpO82rNkK2Ap9yELwn/AwMYokTDraOCzaB06TEdA6ETOEAyk7MZyjiLbAJRyhltMWWXZwhQZzJ6G6sA0dcCnlhGICyMbeAUWCbcEz2es1wrjlXInbJU0N34acR9iMI9b+KwXy/gC227xPKclwXP/XeUESfxhp9hmJeAw/kkD6VcKG4JzbAdj/XkhaIuGBLKdb7JjH/hbWUialywhS3U665FjVp3OupDo9ZCBlLuWarHUJsfFAhj0IKFkKKeRQympet1cjA2KU1pI2oSW9K8azeocfvduCn5Vp1iXUyye2q9/DLwIxmMcFnxeBAfGYw70vgrpSRDtsW+EwtSkWSOO5OmIj4bWtRXJjGJTnsjstjeVD+nrbYTo/pARvfcm3jRwy3lyuuSM3LCQakEOdlxAWpQqbGbIYiPKEqpabCeQcnvqtcuWArYifwIwcivMCBu9tGyEQOgvdCVD0Tq8aOThF7tUNF7KrE1Ja2wjsZMy6ntW1bYTihCFh10fCJEtOUU7o/otEzr1lMCBtMVU2cinDhTrtWwdbbF+Bsyse1MoD/wslAF8CpiGDjpyzFtjhc0xByRaOlUbZt7HTSlykrnnsUe+WDgZ75hAOpAPbERzUbwBJ/AGHShFfzN0J6AAAAAElFTkSuQmCC"
                                        height="25"
                                        alt="settings" />
                                </NavLink>

                                <NavLink
                                    className="btn"
                                    to={'/dashboard/view/' + drone.id}
                                    title={t("dronesOnline.buttons.viewCameras")}
                                >
                                    <img
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABkklEQVR4nO2WvUoDQRSFPwsjoomk8wHEUpNgL9aKnVjYii/hT2FEIwgS8hBKgp1gY6ddYpGHWPNjKRKrRAZuYBj3zu5iRIs9cJs7557D3Duzs5AixT/AGlAGHoEOMJDoSO4UKE3ScBt4AUYxowls/cRwGXhIYOjGPbCU1HQX+AgR6wGHQAGYkygCR7Lm8t+BnTiGU8A5MAwRqQNZT61Za4TUGa0z0VZNa0rb6r5CRyPMfARUNY0rpaAXsVMXOaCvaF265APPITEztZERgVcgACqSs3Hs0dsfk1aBTw/RrNuohHBMzkbRozcAVgypFXEt3DYHIRyTs5GN0GwZUvsXjHMRmm1D2lCuzzgKMVp9kaDVQ2B9TKx6iObjYCMj5oHncJ149K5dsecJXacF4E3RegKm3YK8Z96NBB+QO89c81rhorwumnkuYqeaaVO0vZgFbhWBvnwczLs7L1GSmWrtvRHNWDAt21OuTtwIRCPOiL4hKy+LthutK+WEB1LFDLApr5c5/V3r16cruZpwDDdFCv4MXw/YJO5+W1zLAAAAAElFTkSuQmCC"
                                        height="25"
                                        alt="visible--v1" />
                                </NavLink>

                            </td>
                        </tr>
                    )
                })}

            </table>
            <Pagination
                currentPage={currentPageDrones}
                totalPages={totalPagesDrones}
                onPageChange={handlePageChange}
            />
        </div>
    )
}
export default DronesOnline;